import axios from '@/libs/axios'

export default {
  // Wage
  getEmployeesWage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'wage/employees/', method: 'GET', params })
        .then(res => {
          commit('SET_WAGE_DATA', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  makeWageExcelFile({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'wage/export/', method: 'POST', data, responseType: 'blob' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Medical staff
  getMedicalStaff({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'wage/medical-staff/', method: 'GET', params })
        .then(res => {
          commit('SET_MEDICAL_STAFF', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
}
